//
import { createAction } from 'redux-actions';

export const addNotifications = createAction('ADD_NOTIFICATIONS');
export const removeNotifications = createAction('REMOVE_NOTIFICATIONS');
